<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-users">
      New Group
    </page-title>

    <v-form @submit.prevent="submit"
            ref="form"
            :disabled="form.busy">
      <v-card>
        <v-card-text>

          <group-form :form="form">
          </group-form>

        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 :disabled="form.busy"
                 color="primary">
            Create
          </v-btn>
          <v-btn :to="{name: 'admin.groups.index'}"
                 exact>
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>

import GroupForm from './components/GroupForm';
import DOMPurify from 'dompurify';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, GroupForm},
  metaInfo() {
    this.$store.commit('setTitle', 'Create Group');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Groups', exact: true, to: {name: 'admin.groups.index'},},
        {text: 'Create Group'},
      ],
      form: new Form({
        name: '',
        presentations: [],
        templates: [], // MLD-5194
        users: [],
      })
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/groups`)
        .then(async (response) => {
          this.$toast.success(`${DOMPurify.sanitize(this.form.name)} has been created.`);
          await this.$store.dispatch('fetchGroups');
          this.$emit('updated');
          await this.$router.push({name: 'admin.groups.index'});
        })
        .catch(err => {

        })
    }
  }
}
</script>
